export enum AccessRules {
	'dev' = 1, // full access
	'level_i' = 2, // config + admin + delete + view all
	'level_ii' = 3, // admin + delete + view all
	'level_iii' = 4, // normal + view routes
	'level_iv' = 5, // operator + view report
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/access_rules.ts